module.exports = __webpack_public_path__ + "assets/img/Dialog.db24c8db.svg";